<template>
  <el-popover
    :class="device.isMobile ? 'popover-mobile' : ''"
    :id="content.key"
    placement="top"
    :title="content.popTitle"
    trigger="click"
    :append-to-body="content.inBody && content.inBody == 1"
    @click.stop="
      (e) => {
        findChapterFrom(e)
        e.stopPropagation();
      }
    "
  >
    <div
      class="popover-box"
      :id="`${content.key}-1`"
      :class="device.isMobile ? 'popover-box-mobile' : ''"
    >
      <!-- 可配置内容 -->
      <div v-if="content.content && content.content.length > 0">
        <commonIndex :bookContent="content.content"></commonIndex>
      </div>
      <!-- <el-image v-else-if="content.popImage" class="popover-img" :src="content.popImage" :fit="fit" :preview-src-list="[content.popImage]"></el-image> -->
      <!-- 纯图片 -->
      <el-image
        v-else-if="content.popImage"
        class="popover-img"
        :src="content.popImage"
        fit="fit"
      ></el-image>
      <!-- 纯文字 -->
      <div
        v-else-if="content.popText"
        class="popover-text"
        :id="`${content.key}-1-1`"
      >
        {{ content.popText }}
      </div>
      <!-- 右侧超链接 -->
      <a
        v-if="content.popLink"
        class="popover-link"
        :id="`${content.key}-1-2`"
        :href="content.popLink"
        target="_blank"
      >
        <img
          :id="`${content.key}-1-2-1`"
          :src="
            content.popLinkIcon ||
            require('@/assets/images/bookContent/bubble-icon-link.png')
          "
          alt=""
          class="popover-link-icon"
        />
      </a>
      <!-- 英语单词详情 start -->
      <div class="word_info" v-else-if="content.popWord">
        <div class="word_info_title">
          <div class="title_left">
            <span
              v-for="(item, index) in content.popWordTitle"
              :key="index"
              :style="{
                color: item.textStyle.color || '',
                fontWeight: content.textStyle.fontWeight || '',
                fontFamily: content.textStyle.fontFamily || '',
                fontSize: content.textStyle.fontSize + 'rem' || '',
              }"
              >{{ item.text }}</span
            >
          </div>
          <img
            :src="
              !content.isPlay
                ? require('@/assets/images/books/book2/play_default.png')
                : require('@/assets/images/books/book2/play_process.png')
            "
            alt=""
            class="title_right"
            @click="audioPlayClick(content)"
          />
        </div>
        <div class="word_info_content">
          <div
            class="content"
            v-for="(item, index) in content.popWordList"
            :key="index"
          >
            <div class="content_top" v-if="item.text">
              <span></span><span>{{ item.text }}</span>
            </div>
            <div class="content_bottom">
              <div v-for="(items, index) in item.content" :key="index">
                <template v-if="!items.textFlex">
                  <span
                    v-for="(ite, ind) in items.content"
                    :key="ind"
                    :style="{
                      fontFamily: ite.textStyle.fontFamily || '',
                      fontSize: ite.textStyle.fontSize + 'rem' || '',
                      color: ite.textStyle.color || '',
                      fontStyle: ite.textStyle.fontItalic === 1 ? 'italic' : '',
                      fontWeight: ite.textStyle.fontWeight || '',
                    }"
                    >{{ ite.text }}</span
                  ></template
                >
                <template v-else>
                  <div class="flex_box">
                    <div class="flex_left">
                      <span
                        :style="{
                          fontFamily:
                            item.content[index].content[0].textStyle
                              .fontFamily || '',
                          fontSize:
                            item.content[index].content[0].textStyle.fontSize +
                              'rem' || '',
                          color:
                            item.content[index].content[0].textStyle.color ||
                            '',
                          fontStyle:
                            item.content[index].content[0].textStyle
                              .fontItalic === 1
                              ? 'italic'
                              : '',
                          fontWeight:
                            item.content[index].content[0].textStyle
                              .fontWeight || '',
                        }"
                      >{{ item.content[index].content[0].text }}</span>
                    </div>
                    <div class="flex_right">
                      <span
                        v-for="(ite, ind) in items.content.slice(1)"
                        :key="ind"
                        :style="{
                          fontFamily: ite.textStyle.fontFamily || '',
                          fontSize: ite.textStyle.fontSize + 'rem' || '',
                          color: ite.textStyle.color || '',
                          fontStyle:
                            ite.textStyle.fontItalic === 1 ? 'italic' : '',
                          fontWeight: ite.textStyle.fontWeight || '',
                          display: 'block',
                        }"
                      >{{ ite.text }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 英语单词详情 end -->
      <!-- 节日介绍 start -->
      <div class="word_info" v-else-if="content.translate">
        <div class="word_info_content">
          <div
            class="content"
            v-for="(item, index) in content.popWordList"
            :key="index"
          >
            <div class="content_top" v-if="item.text">
              <span></span><span>{{ item.text }}</span>
            </div>
            <div class="content_bottom">
              <div v-for="(items, index) in item.content" :key="index">
                <template v-if="!items.textFlex">
                  <span
                    v-for="(ite, ind) in items.content"
                    :key="ind"
                    :style="{
                      fontFamily: ite.textStyle.fontFamily || '',
                      fontSize: ite.textStyle.fontSize + 'rem' || '',
                      color: ite.textStyle.color || '',
                      fontStyle: ite.textStyle.fontItalic === 1 ? 'italic' : '',
                      fontWeight: ite.textStyle.fontWeight || '',
                    }"
                    >{{ ite.text }} </span
                  ></template
                >
                <template v-else>
                  <div class="flex_box">
                    <div class="flex_left">
                     
                      <span
                        :style="{
                          fontFamily:
                            item.content[index].content[0].textStyle
                              .fontFamily || '',
                          fontSize:
                            item.content[index].content[0].textStyle.fontSize +
                              'rem' || '',
                          color:
                            item.content[index].content[0].textStyle.color ||
                            '',
                          fontStyle:
                            item.content[index].content[0].textStyle
                              .fontItalic === 1
                              ? 'italic'
                              : '',
                          fontWeight:
                            item.content[index].content[0].textStyle
                              .fontWeight || '',

                        }"
                      >
                        {{ item.content[index].content[0].text }}
                      </span>
                    </div>
                    <div class="flex_right">
                      <span
                        v-for="(ite, ind) in items.content.slice(1)"
                        :key="ind"
                        :style="{
                          fontFamily: ite.textStyle.fontFamily || '',
                          fontSize: ite.textStyle.fontSize + 'rem' || '',
                          color: ite.textStyle.color || '',
                          fontStyle:
                            ite.textStyle.fontItalic === 1 ? 'italic' : '',
                          fontWeight: ite.textStyle.fontWeight || '',
                          display: 'block',
                        }"
                      >
                        {{ ite.text }}
                      </span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
       <!-- 节日介绍 end -->
    </div>
    <!-- 正文中展示的内容 -->
    <span
      :id="`${content.key}-2`"
      slot="reference"
      class="pop-font"
      :style="{
        fontFamily: content.textStyle.fontFamily || '',
        fontSize: content.textStyle.fontSize + 'rem' || '',
        lineHeight: content.textStyle.lineHeight + 'rem' || '',
        textIndent:
          content.textStyle.textIndent &&
          typeof content.textStyle.textIndent === 'string'
            ? content.textStyle.textIndent
            : content.textStyle.textIndent &&
              typeof content.textStyle.textIndent === 'number'
            ? content.textStyle.textIndent + 'rem'
            : '',
        fontWeight: content.textStyle.fontWeight || '',
        textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.textStyle.textAlign || '',
        color: content.textStyle.color || '',
        backgroundColor: content.textStyle.backgroundColor || '',
      }"
      @click.stop="
        (e) => {
          findChapterFrom(e)
          e.stopPropagation();
        }
      "
    >
    <!-- {{ content }} -->
      <slot
        v-if="content.textSlot === 1"
        :id="`${content.key}-2`"
        name="popContent"
      ></slot>
      <template v-else>
        <span :id="`${content.key}-2-1`" v-if="content.popWord_play"
          >
          <span v-for="(itemss, indexss) in content.allContent" :key="indexss" :style="{
            color: itemss.textStyle.color || '',
            fontFamily: itemss.textStyle.fontFamily || '',
            fontSize: itemss.textStyle.fontSize + 'rem' || '',
            fontStyle: itemss.textStyle.fontItalic === 1 ? 'italic' : '',
            fontWeight:itemss.textStyle.fontWeight || '',
          }">
         {{ itemss.text }}
          </span></span
        >
        <span class="pop-text" :id="`${content.key}-2-1`" v-else>{{ content.text }}</span>
        <sup class="pop-index" :id="`${content.key}-2-2`" v-if="content.popIndex">{{ content.popIndex }}</sup>
        <img
          :id="`${content.key}-2-3`"
          src="@/assets/images/bookContent/bubble.png"
          alt=""
          class="pop-icon"
          :style="{
            marginLeft:
              content.isreset == true || content.isreset == false
                ? '13rem'
                : '',
          }"
        />
      </template>
    </span>
    <audio src="" id="audio_word"></audio>
  </el-popover>
</template>
<script>
/*
气泡
*/
export default {
  name: "popover",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  components: {
    commonIndex: () => import("../../index.vue"), //解决递归加载组件报错
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    //音频播放点击
    audioPlayClick(item) {
     
      item.isPlay = !item.isPlay;
      if (item.isPlay) {
        var audio = document.getElementById("audio_word");
        audio.src = item.word_url;
        audio.play();
      } else {
        var audio = document.getElementById("audio_word");
        audio.pause();
      }
      audio.addEventListener("ended", function () {
        console.log("音频播放完成");
        item.isPlay = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.popover-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 650rem;
  min-width:450rem;
  text-indent: 0;
  .popover-link {
    flex: 0 0 20rem;
    width: 20rem;
    height: 20rem;
    display: block;
    margin-left: 10rem;

    .popover-link-icon {
      width: 20rem;
      height: 20rem;
      display: block;
    }
  }

  .popover-img {
    max-width: 500rem;
    max-height: 300rem;
  }

  /deep/span{
    user-select: text !important;
  }
}
.pop-font {
  color: #0281ec;
  position: relative;
  cursor: pointer;
  word-break: word-break;

  .pop-text {
    padding-right: 4rem;
    user-select: text !important;
  }

  .pop-index{
    margin-right: 2rem;
    line-height: 20rem;
  }

  .pop-icon {
    width: 14rem;
    height: 14rem;
    display: inline;
    margin-bottom: 8rem;
  }
}

.popover-box.popover-box-mobile {
  .popover-link {
    flex: 0 0 24rem;
    width: 24rem;
    height: 24rem;
    margin-left: 10rem;

    .popover-link-icon {
      width: 24rem;
      height: 24rem;
    }
  }
  .word_info {
    .word_info_title {
      .title_left {
        span:nth-child(1) {
          font-size: 36rem;
        }
        span:nth-child(2) {
          font-size: 28rem;
        }
      }
      img {
        width: 38rem;
        height: 38rem;
        cursor: pointer;
      }
    }
    .word_info_content {
      padding-top: 16rem;
    }
  }
  .content {
    .content_top {
      span:nth-child(2) {
        font-size: 28rem;
      }
    }
    .content_bottom {
      font-size: 26rem;
    }
  }
  .flex_box {
    .flex_left {
      white-space: pre-wrap;
      // width: 45rem;
    }
  }
}
.popover-mobile {
  .pop-font {
    .pop-text {
      padding-right: 8rem;
    }
    .pop-icon {
      width: 22rem;
      height: 22rem;
      margin-bottom: 4rem;
    }
  }
}
.word_info {
  width: 100%;
  .word_info_title {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1rem solid #e3e3e3;
    padding-bottom: 10rem;
    .title_left {
      span:nth-child(1) {
        color: #333333;
        font-size: 30rem;
        font-weight: bold;
      }
      span:nth-child(2) {
        margin-left: 12rem;
        color: #999;
        font-size: 26rem;
      }
    }
    img {
      width: 38rem;
      height: 38rem;
      cursor: pointer;
    }
  }
  .word_info_content {
    padding-top: 16rem;
  }
}
.content {
  margin-bottom: 16rem;
  .content_top {
    display: flex;
    align-items: center;
    span {
      display: inline-block;
    }
    span:nth-child(1) {
      width: 4rem;
      height: 18rem;
      background: #5ca683;
      border-radius: 1.5rem;
    }
    span:nth-child(2) {
      margin-left: 12rem;
      color: #333333;
      font-size: 24rem;
    }
  }
  .content_bottom {
    font-size: 22rem;
    line-height: 40rem;
    text-align: left;
    white-space: pre-wrap;
  }
}
.flex_box {
  display: flex;
  .flex_left {
    white-space: pre-wrap;
    word-break: keep-all;
    //width: 35rem;
  }
  .flex_right {
    flex: 1;
  }
}
</style>